const CustomTheme = {
  token: {
    colorPrimary: "#26245d",
    colorSplit: 'white'
  }
}

export default CustomTheme;

